import { jsx as _jsx } from "react/jsx-runtime";
import Error from 'portal-common/components/Error';
export default function ErrorPage() {
    return(/*#__PURE__*/ _jsx(Error, {
        code: '404'
    }));
};
